import { Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ReactComponent as MediaIcon } from 'assets/icons/edit-image.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit-white.svg';
import { DrawerMedia, GridWrap, InfoWrapper, Table } from 'components';
import {
  FieldType,
  MediaGroup,
  SchemaPonteCommonTableValue,
  UploadMedia,
} from 'constants/inspections';
import {
  marciapiedePresenteOptions,
  sormontabilitaMarciapiedeOptions,
  tipologiaMarciapiedeOptions,
} from 'constants/selectOptions';
import { useInspectionPath } from 'hooks';
import { INFO } from 'pages/Inspections/config/info';
import { useInspectionSelector } from 'stores';
import MarciapiediForm from './MarciapiediForm';
const MarciapiediSection = ({ selectedIdx }) => {
  const { watch, setValue, getValues } = useFormContext();
  const { inspectionDisabled } = useInspectionSelector();
  const { isViewingInspection } = useInspectionPath();

  const sovrastrutturaImpalcatoTableMarciapiediTableWatch = watch(
    `sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable`
  );

  // table setup
  const dataConfigMarciapiedi = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaMarciapiede: {
        label: 'Tipologia Marciapiede',
        format: tipologiaMarciapiedeOptions,
      },
      tipologiaAltroMarciapiede: {
        label: 'Tipologia Marciapiede (Altro)',
      },
      marciapiedePresente: {
        label: 'Marciapiede Presente',
        format: marciapiedePresenteOptions,
      },
      sormontabilitaMarciapiede: {
        label: 'Sormontabilità Marciapiede',
        format: sormontabilitaMarciapiedeOptions,
      },
      larghezzaMarciapiede: {
        label: 'L [cm]',
      },
      altezzaMarciapiede: {
        label: 'H [cm]',
      },
      superficieMarciapiede: {
        label: 'S [m²]',
      },
    },
  };

  // marciapiedi setup
  const [selectedMarciapiedi, setSelectedMarciapiedi] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();

  const editRowsMarciapiedi = item => {
    setValue('l0t3a2_marciapiedeTableValue', [item]);
    setValue(
      'l0t3a2_tipologiaMarciapiedeTableValue',
      item.tipologiaMarciapiede
    );
    setValue(
      'l0t3a2_tipologiaAltroMarciapiedeTableValue',
      item.tipologiaAltroMarciapiede
    );
    setValue('l0t3a2_marciapiedePresenteTableValue', item.marciapiedePresente);
    setValue(
      'l0t3a2_sormontabilitaMarciapiedeTableValue',
      item.sormontabilitaMarciapiede
    );
    setValue(
      'l0t3a2_larghezzaMarciapiedeTableValue',
      item.larghezzaMarciapiede
    );
    setValue('l0t3a2_altezzaMarciapiedeTableValue', item.altezzaMarciapiede);
    setValue(
      'l0t3a2_superficieMarciapiedeTableValue',
      item.superficieMarciapiede
    );
  };

  const handleSelectAllClickMarciapiedi = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable`
      );
      const filteredValue = selectedValue.filter(
        el => el.presenza === SchemaPonteCommonTableValue.Uno
      );
      setSelectedMarciapiedi(filteredValue);
      setValue('l0t3a2_marciapiedeTableValue', filteredValue);
    } else {
      setSelectedMarciapiedi([]);
      setValue('l0t3a2_marciapiedeTableValue', []);
    }
  };

  return (
    <>
      <InfoWrapper
        isDivider={true}
        size={12}
        infoDrawer={true}
        drawerTitle={INFO.impalcatoMarciapiede.drawerTitle}
        drawerText={INFO.impalcatoMarciapiede.drawerText}
      >
        <Divider sx={{ marginTop: 3 }}>MARCIAPIEDI</Divider>
      </InfoWrapper>
      {sovrastrutturaImpalcatoTableMarciapiediTableWatch?.length === 0 && (
        <GridWrap item xs={12}>
          <Typography>
            Nessun marciapiede previsto in questo elemento
          </Typography>
        </GridWrap>
      )}
      {sovrastrutturaImpalcatoTableMarciapiediTableWatch?.every(
        el => el.assente
      ) &&
        sovrastrutturaImpalcatoTableMarciapiediTableWatch?.length > 0 && (
          <GridWrap item xs={12}>
            <Typography>
              Nessun marciapiede presente in questo elemento
            </Typography>
          </GridWrap>
        )}
      {sovrastrutturaImpalcatoTableMarciapiediTableWatch?.filter(
        el => !el.assente
      ).length > 0 && (
        <>
          {!inspectionDisabled && !isViewingInspection && (
            <MarciapiediForm
              marciapiediFields={
                sovrastrutturaImpalcatoTableMarciapiediTableWatch || []
              }
              selected={selectedMarciapiedi}
              setSelected={setSelectedMarciapiedi}
              marciapiediTable={`sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable`}
              selectedIdx={selectedIdx}
            />
          )}
          <DrawerMedia
            open={open}
            setOpen={setOpen}
            title={'Marciapiedi'}
            infoPanel="Per un'ottimizzazione nel report, si consiglia di eseguire foto in orizzontale in rapporto 4:3."
            dataType="video/*,image/*"
            uploadType={UploadMedia.media}
            type={FieldType.images}
            formName={`sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable[${drawerMediaIndex}].media`}
            mediaGroup={[MediaGroup.Sovrastruttura]}
          />
          <GridWrap container spacing={2} mt={2}>
            <GridWrap item xs={12}>
              <Table
                data={
                  sovrastrutturaImpalcatoTableMarciapiediTableWatch.filter(
                    el => !el.assente
                  ) || []
                }
                config={dataConfigMarciapiedi}
                hasCheckbox={!inspectionDisabled && !isViewingInspection}
                rowActions={
                  !inspectionDisabled && !isViewingInspection
                    ? [
                        {
                          onClick: item => {
                            editRowsMarciapiedi(item);
                            setSelectedMarciapiedi([item]);
                          },
                          icon: <EditIcon />,
                        },
                      ]
                    : []
                }
                mediaActions={[
                  {
                    onClick: item => {
                      setDrawerMediaIndex(
                        sovrastrutturaImpalcatoTableMarciapiediTableWatch.findIndex(
                          el => el.id === item.id
                        )
                      );
                      setOpen(true);
                    },
                    icon: <MediaIcon />,
                  },
                ]}
                selected={selectedMarciapiedi}
                onSelectAllClick={handleSelectAllClickMarciapiedi}
                setSelected={setSelectedMarciapiedi}
              />
            </GridWrap>
          </GridWrap>
        </>
      )}
    </>
  );
};
MarciapiediSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default MarciapiediSection;
